import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/forge/ufudu.sonnenglas.net/releases/20250720205340/layouts/default.vue").then(m => m.default || m))
}